import { render } from "./Activacion.vue?vue&type=template&id=6b61982c&scoped=true"
import script from "./Activacion.vue?vue&type=script&lang=js"
export * from "./Activacion.vue?vue&type=script&lang=js"

import "./Activacion.vue?vue&type=style&index=0&id=6b61982c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b61982c"]])

export default __exports__